<template>
    <div id="globalLoading" class="globalLoading" :class="['globalLoading']" v-show="finalText != ''">
        <div class="bg"></div>
        <div>
            <loadingIcon :style="{zIndex}" ref="icon" ></loadingIcon>
            <p><span class="text"><i>{{finalText}}</i><i>...</i></span></p>
        </div>
    </div>
</template>

<script type="text/javascript">
    import loadingIcon from './loadingIcon.vue';
    import viploadingIcon from '@/components/vip/common/loadingIcon.vue';

    export default {
        name: 'globalLoading',
        components: {
            loadingIcon,
            viploadingIcon
        },
        props: {
            propLOADINGTEXT: {
                required: true,
                type: String,
                default: ''
            },
            zIndex: {
                default: '5'
            }
        },
        data() {
            return {
                finalText: '',
            }
        },
        mounted(){
        },
        watch: {
            propLOADINGTEXT (newVal, oldVal) {
                const that = this;
                if (newVal == '') {
                    setTimeout(() => {
                        that.finalText = newVal;
                        that.stopAnimate();
                    }, 1000)
                } else {
                    that.finalText = newVal;
                    that.playAnimate();
                }
            }
        },


        methods: {
            stopAnimate() {
                var icon = this.$refs.icon;
                icon && icon.getAnime && icon.getAnime().pause()
            },
            playAnimate() {
                var icon = this.$refs.icon;
                icon && icon.getAnime && icon.getAnime().play()
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import '../../scss/function';

    .globalLoading {
        position: fixed;
        z-index: 99;
        top: 50%;
        left: 50%;
        width: topx(160rem);
        height: topx(120rem);
        padding: topx(20rem) 0;
        // line-height: 45px;
        text-align: center;
        font-size: 0;
        display: flex;
        justify-content: center;
        align-items: center;
        transform: translate(-50%, -50%);
        .bg {
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background: #000;
            opacity: 0.5;
            border-radius: 5px;
        }

        p {
            text-align: center;
            /* font-size: topx(28rem); */
            color: #4C4B58;
            line-height: 1.42;
            span {
                position: relative;
                i {
                    position: relative;
                    display: inline-block;
                    height: topx(34rem);
                    text-align: left;
                    // overflow: hidden;
                    font-style: normal;
                    b {
                        position: absolute;
                        z-index: 1;
                        top: 0;
                        bottom: 0;
                        background: #000;
                        opacity: .75;
                        width: 100%;
                        animation: textLoading 1.5s linear infinite;
                    }
                }
            }
        }
        .text {
            /*margin-top: topx(30rem);*/
            display: inline-block;
            text-align: center;
            font-size: topx(24rem);
            color: #fff;
            line-height: 1.42;
            text-align: center;
            position: relative;
            z-index: 3;
        }
    }
    .vipGlobalLoading{
        .bg {
            opacity: 0.3 !important;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/common/globalLoading.vue